import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { SolutionIntro } from '../components/SolutionIntro';
import { Volumes } from '../components/Volumes';
import { Bonuses } from '../components/Bonuses';
import { Benefits } from '../components/Benefits';
import { SpecialOffer } from '../components/SpecialOffer';
import { Guarantee } from '../components/Guarantee';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { LastChance } from '../components/LastChance';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
export function Home() {
  return <main className="min-h-screen bg-navy-950 text-white font-inter selection:bg-gold-500/30 selection:text-gold-200" data-id="element-259" data-mp="2dirt4w6pcry1">
      <Hero data-id="element-260" data-mp="3kuqun6ykvpi1" />
      <PainPoints data-id="element-261" data-mp="3kxd2l7pds70s" />
      <SolutionIntro data-id="element-262" data-mp="3owvmq19doe2k" />
      <Volumes data-id="element-263" data-mp="3owcejc9j541q" />
      <Bonuses data-id="element-264" data-mp="3ovubnwsd3rku" />
      <Benefits data-id="element-265" data-mp="3ovarsaj5it46" />
      <SpecialOffer data-id="element-266" data-mp="3oyyn9f85pplj" />
      <Guarantee data-id="element-267" data-mp="30wroqfcbfvf0" />
      <Testimonials data-id="element-268" data-mp="30xb9e3tcoxwq" />
      <FAQ data-id="element-269" data-mp="30vqeue71deyv" />
      <LastChance data-id="element-270" data-mp="30w9kowjewcwj" />
      <Footer data-id="element-271" data-mp="30up1u46gmiei" />
      <SalesNotification data-id="element-272" data-mp="30uf7k4edtp30" />
    </main>;
}